<nav class="TotemFooter bg-white text-dark shadow-sm" [attr.aria-label]="'totem-a11y.main-nav' | locTranslate">
    <div [style.backgroundColor]="configData?.footerBackgroundColor" [style.color]="configData?.footerTextColor">
        <div class="d-flex justify-content-between align-items-center pt-1">
            @if (configData?.footerLogo) {
                <div class="TotemFooter-Logo">
                    <img [src]="configData?.footerLogo" [alt]="'totem-a11y.logo' | locTranslate"/>
                </div>
            }
            <div class="TotemFooter-Buttons w-100 d-flex justify-content-around">
                @for(button of buttonList; track button.id) {
                    <div>
                        <button type="button" class="btn btn-white {{ openSection == button.id ? 'text-primary' : '' }}" [attr.aria-current]="openSection == button.id ? 'page' : null" [disabled]="openSection == button.id" (click)="openSectionChange.emit(button.id)">
                            <div class="text-center">
                                <i class="fa-regular fa-lg {{button.icon}}" aria-hidden="true"></i>
                            </div>
                            <div>{{ 'totem-footer.button-' + button.id | locTranslate }}</div>
                        </button>
                    </div>
                }
            </div>
        </div>
    </div>
</nav>
